import React from "react";
import { cn } from "@/lib/utils";
import { countries } from "@/utils/countries";

interface RequestGuestNameProps {
  firstName?: string | null;
  lastName?: string | null;
  countryCode?: string | null;
  className?: string;
  nameClassName?: string;
  flagClassName?: string;
}

export const RequestGuestName: React.FC<RequestGuestNameProps> = ({
  firstName,
  lastName,
  countryCode,
  className,
  nameClassName,
  flagClassName,
}) => {
  const fullName = [firstName, lastName].filter(Boolean).join(" ").trim();
  const normalizedCountryCode = countryCode?.toUpperCase();
  const flag =
    countries.find((country) => country.code === normalizedCountryCode)?.flag ||
    null;

  if (!fullName && !flag) {
    return null;
  }

  return (
    <div className={cn("flex min-w-0 items-center gap-2", className)}>
      {flag ? (
        <span className={cn("text-base leading-none shrink-0", flagClassName)}>
          {flag}
        </span>
      ) : null}
      {fullName ? (
        <span className={cn("min-w-0 text-sm font-medium", nameClassName)}>
          {fullName}
        </span>
      ) : null}
    </div>
  );
};
